import NotifyMessage from "@/commonFuncion/NotifyMessage";

// Element UI InputNumber buffers native text until change/blur. Limit it before
// the child input consumes the event, then commit through its normal change event.
export const DISCOUNT_PERCENT_LIMIT_MESSAGE = "Không được nhập quá 100%.";
const listeners = new WeakMap();

export const discountPercentInput = {
  bind(el) {
    const limitInput = (event) => {
      const input = event.target;
      if (event.isComposing || !input || input.tagName !== "INPUT") return;
      if (Number(input.value) > 100) {
        input.value = "0";
        const change = input.ownerDocument.createEvent("HTMLEvents");
        change.initEvent("change", true, false);
        input.dispatchEvent(change);
        NotifyMessage.leftCornerNotificationWarning(DISCOUNT_PERCENT_LIMIT_MESSAGE);
      }
    };
    listeners.set(el, limitInput);
    el.addEventListener("input", limitInput, true);
    el.addEventListener("compositionend", limitInput, true);
  },
  unbind(el) {
    const limitInput = listeners.get(el);
    el.removeEventListener("input", limitInput, true);
    el.removeEventListener("compositionend", limitInput, true);
    listeners.delete(el);
  },
};

// Inspect the actual outgoing data, including overrides and nested invoice items.
// Money discounts and disabled discounts keep their existing business rules.
export function hasOverLimitPercentDiscount(payload) {
  const seen = new WeakSet();
  const visit = (node) => {
    if (!node || typeof node !== "object" || seen.has(node)) return false;
    seen.add(node);
    if (node.discount && node.discountType === "PERCENT" &&
        ["discountNumber", "discountValue"].some((field) => Number(node[field]) > 100)) return true;
    return Object.keys(node).some((key) => visit(node[key]));
  };
  return visit(payload);
}
